import {
  READ_SHEET,
  requestType,
  finishedType,
} from "./../actions/actionTypes";

const initState = {
  is_reading: false,
};

export const fileReaderReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(READ_SHEET):
      return {
        ...state,
        is_reading: true,
      };
    case finishedType(READ_SHEET):
      return {
        ...state,
        is_reading: false,
      };
    default:
      return state;
  }
};
